'use client';

import { useEffect, useState } from 'react';
import { checkForUpdates, updateApplication } from '@/utils/version';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
 // Adjust import based on your UI components

export function VersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const { toast } = useToast();
  
  useEffect(() => {
    // Check for updates on initial load and every 10 minutes
    const checkVersion = async () => {
      const hasUpdate = await checkForUpdates();
      if (hasUpdate) {
        setUpdateAvailable(true);
      }
    };
    
    checkVersion();
    const interval = setInterval(checkVersion, 10 * 60 * 1000); // 10 minutes
    
    return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {
    if (updateAvailable) {
      toast({
        title: "Update Available",
        description: "A new version of the application is available.",
        action: (
          <Button variant="outline" onClick={updateApplication}>
            Update Now
          </Button>
        ),
        duration: Infinity,
      });
    }
  }, [updateAvailable, toast]);
  
  return null; // This component doesn't render anything
}
